module.exports = __webpack_public_path__ + "img/bg_chess_06.d60e39cb.jpg";